/* USER */
export const GET_ALL_USER = "GET_ALL_USER"
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS"
export const GET_ALL_USER_FAIL = "GET_ALL_USER_FAIL"